import Vue from 'vue'

import Swiper from './swiper'

Vue.component('v-swiper', Swiper)